<template>
    <div id="listado-minutas-acuerdos">
    <v-card>
        <v-card-title class="secondary--text mb-4">
        Acuerdos ({{getContratoMinutasAcuerdos.length}})
        <v-spacer></v-spacer>
        <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
        </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row><v-col class="">
          <span class="text-h6">
            Minuta:
            </span>
            <span class="text-h6 font-weight-black">
            {{minuta.numero}}</span>
          <v-spacer></v-spacer>
          <v-btn color="primary"
              rounded
              small
              class="text-capitalize"
              @click="mostrarAgregarAcuerdo = true">
              <v-icon left small>
                mdi-plus
              </v-icon>
              Nuevo
            </v-btn>
          </v-col></v-row>
         <v-row>
          <v-col cols="12">
          <v-data-table
          :headers="headers"
          :items="getContratoMinutasAcuerdos"
          :items-per-page="20"
          >
            <template v-slot:[`item.numero`]="{ item }"
            >
            <span
            class="text-h6 font-weight-medium">

            {{ item.numero }}

            </span>
            </template>

            <template v-slot:[`item.fechaHoraCumplimiento`]="{ item }"
            >
            <span
            v-show="item.fechaHoraCumplimiento !== null">
            <v-chip class="mx-2" small color="success">
            {{ new Date(item.fechaHoraCumplimiento).toISOString().split('T')[0]}}
            </v-chip>
            </span>
            </template>
            <template v-slot:[`item.acciones`]="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                  <v-icon @click="editar(item)">
                      mdi-pencil
                  </v-icon>
                  </v-btn>
              </template>
              <span>
                  Editar Acuerdo
              </span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn x-small icon rounded v-bind="attrs" v-on="on">
                <v-icon @click="eliminar(item)">
                    mdi-delete
                </v-icon>
                </v-btn>
              </template>
              <span>
                  Eliminar Acuerdo
              </span>
            </v-tooltip>
            </template>
          </v-data-table>
          </v-col>
         </v-row>
    </v-card-text>
    </v-card>
    <!-- Ventana Agregar Acuerdo -->
    <v-dialog
    v-if="mostrarAgregarAcuerdo"
    v-model="mostrarAgregarAcuerdo"
    width="600"
    persistent>
    <AgregarMinutaAcuerdo
    v-on:cerrar="mostrarAgregarAcuerdo=!mostrarAgregarAcuerdo"
    :idMinuta="idMinuta"
    />
  </v-dialog>
  <!-- Ventana Editar Acuerdo -->
    <v-dialog
    v-if="mostrarEditarAcuerdo"
    v-model="mostrarEditarAcuerdo"
    width="600"
    persistent>
    <EditarMinutaAcuerdo
    v-on:cerrar="mostrarEditarAcuerdo=!mostrarEditarAcuerdo"
    :minutaAcuerdoEditar="esteAcuerdo"/>
  </v-dialog>
  <!-- Ventana Eliminar Acuerdo -->
    <v-dialog
    v-if="mostrarEliminarAcuerdo"
    v-model="mostrarEliminarAcuerdo"
    width="600"
    persistent>
    <EliminarMinutaAcuerdo
    v-on:cerrar="mostrarEliminarAcuerdo=!mostrarEliminarAcuerdo"
    :minutaAcuerdoEliminar="esteAcuerdo"/>
  </v-dialog>
    </div>

</template>
<script>
import CONTRATO_MINUTAS_ACUERDOS from '@/graphql/querys/administracion/minutas/contratoMinutasAcuerdos.gql';
import AgregarMinutaAcuerdo from './Nuevo.vue';
import EditarMinutaAcuerdo from './Editar.vue';
import EliminarMinutaAcuerdo from './Eliminar.vue';

export default {
  name: 'ListadoMinutasAcuerdos',
  props: {
    minuta: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      mostrarAgregarAcuerdo: false,
      mostrarEditarAcuerdo: false,
      mostrarEliminarAcuerdo: false,
      esteAcuerdo: {},
      idMinuta: this.minuta.id,
      headers: [
        { text: 'Número', value: 'numero', sortable: true },
        { text: 'FLimite', value: 'fechaLimite', sortable: true },
        { text: 'FCumplimiento', value: 'fechaHoraCumplimiento', sortable: true },
        { text: 'Descripción', value: 'descripcion', sortable: true },
        { text: 'Reponsables', value: 'nombreReponsable', sortable: true },
        // { text: 'Puesto', value: 'puestoResponsable', sortable: true },
        {
          text: '', value: 'acciones', align: 'end', sortable: false,
        },
      ],
    };
  },
  components: {
    AgregarMinutaAcuerdo,
    EditarMinutaAcuerdo,
    EliminarMinutaAcuerdo,
  },
  apollo: {
    contratoMinutasAcuerdos: {
      query: CONTRATO_MINUTAS_ACUERDOS,
      variables() {
        return {
          idMinuta: this.idMinuta,
        };
      },

    },
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    editar(item) {
      this.esteAcuerdo = item;
      this.mostrarEditarAcuerdo = true;
    },
    eliminar(item) {
      this.esteAcuerdo = item;
      this.mostrarEliminarAcuerdo = true;
    },
  },
  computed: {
    getContratoMinutasAcuerdos() {
      if (!this.contratoMinutasAcuerdos) return [];
      return this.contratoMinutasAcuerdos
        .slice()
        .sort((a, b) => a.numero - b.numero);
      // .sort((a, b) => new Date(b.fechaHoraCumplimiento) - new Date(a.fechaHoraCumplimiento))
      // .sort((a, b) => new Date(a.fechaLimite) - new Date(b.fechaLimite));
    },
  },
};
</script>
